// extracted by mini-css-extract-plugin
module.exports = {"backButton":"BackArrow_backButton__3qDYd","backArrow":"BackArrow_backArrow__Wq0Cb"};